import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'keyup input.filter-term': 'updateFilter',
  },

  initialize({ placeholder }) {
    this.placeholder = placeholder;
    this.collection.filterTerm = '';
  },

  updateFilter(e) {
    const newTerm = this.$(e.currentTarget).val();
    if (newTerm !== this.collection.filterTerm) {
      this.collection.filterTerm = newTerm;
      this.collection.trigger('filtered');
    }
  },

  context() {
    return {
      placeholder: this.placeholder,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/carrier_accounts/filter/index.js